import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { Row, Col, Button, Input, message } from 'antd'
import AdminLayout from 'components/elements/AdminLayout'
import SectionContent from 'components/elements/SectionContent'
import ServiceTimeCalendar from './ServiceTimeCalendar'
import AppointmentTypeCards from './AppointmentTypeCards'
import Item from './Item'

import {
  appointmentTypeActions
} from 'actions'

const createPath = '/admin/patients/create'
const editPath = '/admin/patients/edit'

class Users extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleCreateButtonOnClick = this.handleCreateButtonOnClick.bind(this)
    this.handleTableOnChange = this.handleTableOnChange.bind(this)
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    // this.chooseSendReminders = this.chooseSendReminders.bind(this)
  }

  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(previousProps) {
    if (previousProps.isFetchItemsLoading && this.props.fetchItemsError) {
      message.error(this.props.fetchItemsError)
    }
  }

  fetch() {
    appointmentTypeActions.fetch()
  }

  handleCreateButtonOnClick(e) {
    e.preventDefault()
    this.props.history.push(createPath)
  }

  async handleTableOnChange(pagination, filters, sorter) {
    const { columnKey, field, order } = sorter
    await this.props.changeTable({
      pagination,
      filters,
      sorter: {
        columnKey,
        field,
        order,
      },
    })
    this.fetch()
  }

  handleOnSelect(appointmentType) {
    if(appointmentType){
      this.props.history.push(`/admin/appointment-types/${appointmentType.id}`)
    }
  }

  handleCreate() {
    this.props.history.push(`/admin/appointment-types/new`)
  }

  async handleSearchOnClick() {
    await this.props.searchTable({ isSearching: true })
    await this.props.changeTable({})
    this.fetch()
  }

  async handleSearchOnCancel(e) {
    e.preventDefault()
    await this.props.editSearch({ search: null })
    await this.props.searchTable({ isSearching: false })
    await this.props.changeTable({})
    this.fetch()
  }

  get chooseSendReminders() {
    console.log(this.props, "this is props ==========-------")
    // return this.props
  }

  render() {
    let showShiftCalendar = true
    
    return (
      <div>
        <AdminLayout>
          <SectionContent noPadding noMargin title='Appointment Types'>
          <Switch>
            <Route exact path='/admin/appointment-types/:id/edit-service-times' render={()=>
              <ServiceTimeCalendar />
            }/>
            <Route path='/admin/appointment-types' render={()=>
              <Row style={{height: '100%'}}>
                <Col xs={24} lg={8}>
                  <AppointmentTypeCards
                    dataSource={this.props.appointmentTypes || []}
                    onSelect={this.handleOnSelect}
                    onCreate={this.handleCreate}
                    editPath={editPath}
                    />
                </Col>
                <Col xs={24} lg={16}>
                  <Route path='/admin/appointment-types/:id' component={Item} />
                </Col>
              </Row>
            }/>
          </Switch>
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

export default withRouter(connect((state)=>(state))(Users))
